import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEvent, IEventInitialState } from "./eventModel";
import {
  ActiveInactiveEvents,
  EventsImageUpload,
  createEvents,
  deleteEvents,
  deleteEventsImage,
  getAllActiveEvents,
  getAllEvents,
  getEventsByID,
  updateEvents,
} from "./services/event.services";

const initialState: IEventInitialState = {
  loading: false,
  formLoading: false,
  EventImageLoading: false,
  error: "",
  EventID: null,
  EventImageID: null,
  EventList: [],
  EventDetail: {
    ID: null,
    Title: "",
    URL: "",
    Tagline: "",
    Capacity: "",
    RomanticSettings: "",
    GuestCapacity: "",
    CustomPackages: "",
    ShortDescription: "",
    LongDescription: "",
    PackageHighlights: "",
    Inclusion: "",
    Exclusion: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    IsActive: 1,
  },
};

const eventSlice = createSlice({
  name: "event",
  initialState,
  reducers: {
    clearEventDetails: (state) => {
      state.EventDetail = initialState.EventDetail;
    },
    setEventID: (state, action) => {
      state.EventID = action.payload;
    },
    clearEventID: (state) => {
      state.EventID = initialState.EventID;
    },
    seteventImageID: (state, action) => {
      state.EventImageID = action.payload;
    },
    clearEventImageID: (state) => {
      state.EventImageID = initialState.EventImageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllEvents.fulfilled,
      (state, action: PayloadAction<IEvent[]>) => {
        state.loading = false;
        state.EventList = action.payload || [];
      },
    );
    builder.addCase(getAllEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EventList = [];
    });
    builder.addCase(createEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createEvents.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateEvents.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteEvents.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getEventsByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getEventsByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.EventDetail = action.payload;
    });
    builder.addCase(getEventsByID.rejected, (state, action) => {
      state.loading = false;
      state.EventDetail = initialState.EventDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveEvents.fulfilled,
      (state, action: PayloadAction<IEvent[]>) => {
        state.loading = false;
        state.EventList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.EventList = [];
    });
    builder.addCase(ActiveInactiveEvents.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveEvents.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveEvents.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(EventsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(EventsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(EventsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteEventsImage.pending, (state) => {
      state.EventImageLoading = true;
      state.error = "";
    });
    builder.addCase(deleteEventsImage.fulfilled, (state) => {
      state.EventImageLoading = false;
    });
    builder.addCase(deleteEventsImage.rejected, (state, action) => {
      state.EventImageLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearEventDetails,
  clearEventID,
  setEventID,
  seteventImageID,
  clearEventImageID,
} = eventSlice.actions;
export default eventSlice.reducer;
